import axios from "axios";
import { HOMEAPI} from "./auth";

const homeapi = axios.create({
  baseURL: HOMEAPI.MDP,
});
homeapi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");        
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
homeapi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const res = await axios.post(HOMEAPI.MDP + "/token/refresh", {
        refresh_token: localStorage.getItem("refresh_token"),
      });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("refresh_token", res.data.refresh_token);
      return homeapi(originalRequest);
    }
    return Promise.reject(error);
  }
);

export default homeapi;